import { render, staticRenderFns } from "./CustomerLocation.vue?vue&type=template&id=8e3e495a"
import script from "./CustomerLocation.vue?vue&type=script&lang=js"
export * from "./CustomerLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports